import type { CompanionCity } from './types';

/** شهرهای همراهان — متن‌ها placeholder تا جایگزینی با روایت واقعی ویدیو/ویس */
export const companionCities: CompanionCity[] = [
  {
    id: 'tehran',
    city: 'تهران',
    country: 'ایران',
    lat: 35.6892,
    lng: 51.389,
    companions: 740,
    highlight: 'قلب شبکه من حقیقی',
    story: 'جامعه اصلی دوره‌ها و تمرین‌های خودشناسی؛ نقطه شروع بسیاری از مسیرهای تحول.',
    region: 'ایران',
    tone: '#7c3aed',
    videoTitle: 'روایت همراه تهران — متن نمونه',
    videoDuration: '۰۲:۰۰',
  },
  {
    id: 'vienna',
    city: 'وین',
    country: 'اتریش',
    lat: 48.2082,
    lng: 16.3738,
    companions: 28,
    highlight: 'رشد آگاهانه در قلب اروپا',
    story: 'همراهی که مسیر خودشناسی من حقیقی را کنار زندگی شهری آرام وین دنبال می‌کند. [متن نمونه — جایگزین با روایت واقعی]',
    region: 'اروپا',
    tone: '#dc2626',
    videoTitle: 'صدای همراه وین — متن نمونه',
    videoDuration: '۰۱:۵۲',
  },
  {
    id: 'amsterdam',
    city: 'آمستردام',
    country: 'هلند',
    lat: 52.3676,
    lng: 4.9041,
    companions: 36,
    highlight: 'تمرین روزانه در سبک زندگی مهاجرتی',
    story: 'روایت کوتاه از یادگیری مدیریت احساسات و ساختن عادت‌های تازه در آمستردام. [متن نمونه]',
    region: 'اروپا',
    tone: '#06b6d4',
    videoTitle: 'گفت‌وگو با همراه آمستردام — متن نمونه',
    videoDuration: '۰۱:۴۸',
  },
  {
    id: 'stockholm',
    city: 'استکهلم',
    country: 'سوئد',
    lat: 59.3293,
    lng: 18.0686,
    companions: 22,
    highlight: 'تمرکز بر آرامش ذهن و نظم',
    story: 'همراهی که آموزش‌های من حقیقی را با چرخه فصلی و زندگی منظم در سوئد هماهنگ کرده است. [متن نمونه]',
    region: 'اروپا',
    tone: '#0ea5e9',
    videoTitle: 'روایت همراه استکهلم — متن نمونه',
    videoDuration: '۰۲:۰۵',
  },
  {
    id: 'cologne',
    city: 'کلن',
    country: 'آلمان',
    lat: 50.9375,
    lng: 6.9603,
    companions: 19,
    highlight: 'حلقه کوچک یادگیری آنلاین',
    story: 'تجربه‌ای از ادامه دوره‌ها و تمرین‌های گروهی در کنار کار و زندگی خانوادگی در آلمان. [متن نمونه]',
    region: 'اروپا',
    tone: '#6366f1',
    videoTitle: 'صدای همراه کلن — متن نمونه',
    videoDuration: '۰۱:۴۴',
  },
  {
    id: 'hamburg',
    city: 'هامبورگ',
    country: 'آلمان',
    lat: 53.5511,
    lng: 9.9937,
    companions: 24,
    highlight: 'بازسازی اعتمادبه‌نفس در مهاجرت',
    story: 'روایت مسیر تحول شخصی از طریق تمرین‌های آگاهی و بازتاب روزانه در هامبورگ. [متن نمونه]',
    region: 'اروپا',
    tone: '#22c55e',
    videoTitle: 'گفت‌وگوی کوتاه هامبورگ — متن نمونه',
    videoDuration: '۰۱:۵۶',
  },
  {
    id: 'berlin',
    city: 'برلین',
    country: 'آلمان',
    lat: 52.52,
    lng: 13.405,
    companions: 61,
    highlight: 'رشد فردی در فضای بین‌فرهنگی',
    story: 'همراهی که دوره‌های من حقیقی را برای بهبود روابط و تصمیم‌گیری آگاهانه در برلین دنبال می‌کند. [متن نمونه]',
    region: 'اروپا',
    tone: '#10b981',
    videoTitle: 'روایت همراه برلین — متن نمونه',
    videoDuration: '۰۲:۱۰',
  },
  {
    id: 'london',
    city: 'لندن',
    country: 'انگلستان',
    lat: 51.5074,
    lng: -0.1278,
    companions: 84,
    highlight: 'تعادل کار، تحصیل و رشد درونی',
    story: 'داستانی از ادامه مسیر خودشناسی در ریتم پرشتاب لندن و یافتن جامعه‌ای هم‌مسیر. [متن نمونه]',
    region: 'اروپا',
    tone: '#2563eb',
    videoTitle: 'صدای همراه لندن — متن نمونه',
    videoDuration: '۰۲:۱۴',
  },
  {
    id: 'izmir',
    city: 'ازمیر',
    country: 'ترکیه',
    lat: 38.4237,
    lng: 27.1428,
    companions: 31,
    highlight: 'یادگیری در کنار زندگی ساحلی',
    story: 'روایت همراهی که تمرین‌های روزانه من حقیقی را به بخشی از سبک زندگی در ازمیر تبدیل کرده است. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#f59e0b',
    videoTitle: 'گفت‌وگو با همراه ازمیر — متن نمونه',
    videoDuration: '۰۱:۵۰',
  },
  {
    id: 'istanbul',
    city: 'استانبول',
    country: 'ترکیه',
    lat: 41.0082,
    lng: 28.9784,
    companions: 96,
    highlight: 'پل فرهنگی بین ایران و اروپا',
    story: 'تجربه‌ای از رشد آگاهی و مدیریت تغییرات زندگی در کلان‌شهر استانبول. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#ea580c',
    videoTitle: 'روایت همراه استانبول — متن نمونه',
    videoDuration: '۰۲:۰۲',
  },
  {
    id: 'dubai',
    city: 'دبی',
    country: 'امارات',
    lat: 25.2048,
    lng: 55.2708,
    companions: 128,
    highlight: 'جامعه فارسی‌زبان پرانرژی',
    story: 'همراهی که مسیر دوره‌ها را کنار چالش‌های کاری و مهاجرت در دبی ادامه داده است. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#C11277',
    videoTitle: 'صدای همراه دبی — متن نمونه',
    videoDuration: '۰۲:۲۴',
  },
  {
    id: 'sharjah',
    city: 'شارجه',
    country: 'امارات',
    lat: 25.3463,
    lng: 55.4209,
    companions: 42,
    highlight: 'تمرکز بر خانواده و رابطه سالم',
    story: 'روایت کوتاه از به‌کارگیری آموزش‌های رابطه و خودآگاهی در زندگی روزمره شارجه. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#db2777',
    videoTitle: 'گفت‌وگوی همراه شارجه — متن نمونه',
    videoDuration: '۰۱:۴۲',
  },
  {
    id: 'abu-dhabi',
    city: 'ابوظبی',
    country: 'امارات',
    lat: 24.4539,
    lng: 54.3773,
    companions: 38,
    highlight: 'پایتخت — رشد آرام و پیوسته',
    story: 'همراهی که در پایتخت امارات، تمرین‌های ذهنی و دوره‌های آنلاین من حقیقی را منظم دنبال می‌کند. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#a855f7',
    videoTitle: 'روایت همراه ابوظبی — متن نمونه',
    videoDuration: '۰۱:۵۸',
  },
  {
    id: 'riyadh',
    city: 'ریاض',
    country: 'عربستان',
    lat: 24.7136,
    lng: 46.6753,
    companions: 35,
    highlight: 'پایتخت — شبکه در حال گسترش',
    story: 'داستانی از شروع مسیر خودشناسی و پیوستن به جامعه آنلاین من حقیقی از ریاض. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#16a34a',
    videoTitle: 'صدای همراه ریاض — متن نمونه',
    videoDuration: '۰۱:۴۶',
  },
  {
    id: 'kuwait-city',
    city: 'کویت',
    country: 'کویت',
    lat: 29.3759,
    lng: 47.9774,
    companions: 27,
    highlight: 'پایتخت — حلقه‌های یادگیری کوچک',
    story: 'روایت همراهی که آموزش‌های من حقیقی را برای مدیریت استرس و تصمیم‌گیری بهتر به کار بسته است. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#0891b2',
    videoTitle: 'گفت‌وگو با همراه کویت — متن نمونه',
    videoDuration: '۰۱:۴۰',
  },
  {
    id: 'manama',
    city: 'منامه',
    country: 'بحرین',
    lat: 26.2285,
    lng: 50.586,
    companions: 18,
    highlight: 'پایتخت — جامعه فشرده و فعال',
    story: 'تجربه‌ای از ادامه تمرین‌های آگاهی و شرکت در دوره‌های آنلاین از منامه. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#7c3aed',
    videoTitle: 'روایت همراه منامه — متن نمونه',
    videoDuration: '۰۱:۳۸',
  },
  {
    id: 'doha',
    city: 'دوحه',
    country: 'قطر',
    lat: 25.2854,
    lng: 51.531,
    companions: 44,
    highlight: 'پایتخت — تعادل ذهن و کار',
    story: 'همراهی که در فضای کاری پرشتاب دوحه، مسیر رشد فردی من حقیقی را حفظ کرده است. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#0f766e',
    videoTitle: 'صدای همراه دوحه — متن نمونه',
    videoDuration: '۰۱:۵۴',
  },
  {
    id: 'muscat',
    city: 'مسقط',
    country: 'عمان',
    lat: 23.588,
    lng: 58.3829,
    companions: 21,
    highlight: 'پایتخت — آرامش و تداوم تمرین',
    story: 'روایت کوتاه از یادگیری خودشناسی و ساختن روتین روزانه در مسقط. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#14b8a6',
    videoTitle: 'گفت‌وگوی همراه مسقط — متن نمونه',
    videoDuration: '۰۱:۴۵',
  },
  {
    id: 'baghdad',
    city: 'بغداد',
    country: 'عراق',
    lat: 33.3152,
    lng: 44.3661,
    companions: 47,
    highlight: 'شبکه در حال رشد در عراق',
    story: 'همراهی که دوره‌های من حقیقی را برای رشد شخصی و بهبود روابط خانوادگی دنبال می‌کند. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#1C3B9B',
    videoTitle: 'روایت همراه بغداد — متن نمونه',
    videoDuration: '۰۲:۰۸',
  },
  {
    id: 'karbala',
    city: 'کربلا',
    country: 'عراق',
    lat: 32.616,
    lng: 44.0249,
    companions: 26,
    highlight: 'جامعه محلی پرانرژی',
    story: 'داستانی از شروع مسیر آگاهی و همراهی با تمرین‌های گروهی آنلاین از کربلا. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#9333ea',
    videoTitle: 'صدای همراه کربلا — متن نمونه',
    videoDuration: '۰۱:۵۱',
  },
  {
    id: 'najaf',
    city: 'نجف',
    country: 'عراق',
    lat: 31.9962,
    lng: 44.3148,
    companions: 23,
    highlight: 'تمرکز بر معنا و رشد درونی',
    story: 'روایت همراهی که آموزش‌های خودشناسی را در زندگی روزمره نجف به کار می‌بندد. [متن نمونه]',
    region: 'خاورمیانه',
    tone: '#4f46e5',
    videoTitle: 'گفت‌وگو با همراه نجف — متن نمونه',
    videoDuration: '۰۱:۴۳',
  },
  {
    id: 'kabul',
    city: 'کابل',
    country: 'افغانستان',
    lat: 34.5553,
    lng: 69.2075,
    companions: 33,
    highlight: 'اتصال از راه دور',
    story: 'تجربه‌ای از ادامه مسیر یادگیری و تمرین‌های من حقیقی با اتکا به محتوای آنلاین از کابل. [متن نمونه]',
    region: 'آسیا',
    tone: '#b45309',
    videoTitle: 'روایت همراه کابل — متن نمونه',
    videoDuration: '۰۲:۱۲',
  },
  {
    id: 'los-angeles',
    city: 'لس‌آنجلس',
    country: 'آمریکا (کالیفرنیا)',
    lat: 34.0522,
    lng: -118.2437,
    companions: 52,
    highlight: 'کالیفرنیا — محتوای صوتی و ویدیویی',
    story: 'همراهی که از مسیر پادکست و دوره‌های آنلاین من حقیقی وارد جامعه شده و مسیر را ادامه می‌دهد. [متن نمونه]',
    region: 'آمریکا',
    tone: '#ec4899',
    videoTitle: 'صدای همراه کالیفرنیا — متن نمونه',
    videoDuration: '۰۱:۵۷',
  },
  {
    id: 'miami',
    city: 'میامی',
    country: 'آمریکا (فلوریدا)',
    lat: 25.7617,
    lng: -80.1918,
    companions: 29,
    highlight: 'فلوریدا — شروع تازه در مهاجرت',
    story: 'روایت کوتاه از بازسازی اعتمادبه‌نفس و یادگیری مدیریت احساسات در میامی. [متن نمونه]',
    region: 'آمریکا',
    tone: '#f97316',
    videoTitle: 'گفت‌وگوی همراه فلوریدا — متن نمونه',
    videoDuration: '۰۱:۴۹',
  },
  {
    id: 'toronto',
    city: 'تورنتو',
    country: 'کانادا',
    lat: 43.6532,
    lng: -79.3832,
    companions: 73,
    highlight: 'جامعه پایدار فارسی‌زبان',
    story: 'همراهی که دوره‌های رشد فردی و عاطفی من حقیقی را در کنار زندگی مهاجرتی تورنتو دنبال می‌کند. [متن نمونه]',
    region: 'آمریکا',
    tone: '#6366f1',
    videoTitle: 'روایت همراه تورنتو — متن نمونه',
    videoDuration: '۰۲:۱۶',
  },
  {
    id: 'sydney',
    city: 'سیدنی',
    country: 'استرالیا',
    lat: -33.8688,
    lng: 151.2093,
    companions: 38,
    highlight: 'دورترین نقطه، اتصال نزدیک',
    story: 'داستانی از حفظ تمرین روزانه و حضور در جلسات آنلاین با اختلاف زمانی زیاد از سیدنی. [متن نمونه]',
    region: 'اقیانوسیه',
    tone: '#14b8a6',
    videoTitle: 'صدای همراه سیدنی — متن نمونه',
    videoDuration: '۰۲:۲۰',
  },
];
